import axios from "axios";
import { Message } from "view-design";
import config from "@/config";
import store from "@/store";
import router from "@/router"

const { env, baseURL, timeout } = config;
// 创建 axios 实例
const ax = axios.create({
  // 是否跨站点访问控制请求使用凭证(Cookie)
  withCredentials: true,
  baseURL: localStorage.getItem("newBaseAPI") || baseURL, // 配置接口地址
  timeout: timeout // 配置请求超时
});
//请求前拦截
ax.interceptors.request.use(
  config => {
    //设置登录用户token
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo){
      config.headers.Authorization = userInfo["accessToken"];
    }
    return config;
  }
)
// 添加 axios 实例响应拦截器
ax.interceptors.response.use(
  response => {
    let res = response.data;
    if (response.headers['content-disposition']){
      let regFileNames = response.headers['content-disposition'].fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称
      return {...res,regFileNames}
    }
    const { errcode, errmsg } = res;
    // 用户 TOKEN 失效
    if (errcode === 3000) {
      store.commit("MENU_RESET"); // 重置菜单
    }
    return res;
  },error => {
    const { response, message, config} = error;
    console.log("http状态码",response.status)
    if (response) {
      // 如果是401 , 提示,并跳出登录页
      if (response.status == 401){
        router.push("/login");
        location.reload();
        Message.error({
          content: "会话已过期,请重新登录吧,亲。"
        });
        return;
      }
      // 如果是403 , 弹出提示, 无操作权限
      if (response.status == 403){
        Message.error({content: "抱歉, 您暂时没有操作权限哦。"});
      }
      store.commit("RES_ERROR", response); // 响应错误数据
    } else {
      console.log("error message:"+message);
      Message.error({content: message});
    }
    console.log(config);
  }
);

// 配置默认参数
const setAuthToken = AUTH_TOKEN => {
  // 配置用户 AUTH_TOKEN
  ax.defaults.headers["Authorization"] = AUTH_TOKEN;
};

// 刷新重新配置默认参数
const userInfo = sessionStorage.getItem("userInfo");
if (userInfo) {
  setAuthToken(JSON.parse(userInfo)["accessToken"]); // 配置默认参数
}

export default ax;
